import api from './api';

const creditService = {
  // Get credit transaction history
  getTransactions: async (params = {}) => {
    try {
      const response = await api.get('/api/credits/transactions', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get current credit balance
  getBalance: async () => {
    try {
      const response = await api.get('/api/credits/balance');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get admin credit analytics (admin only)
  getAnalytics: async (params = {}) => {
    try {
      const response = await api.get('/api/admin/credits/analytics', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get top consuming users within a specific project (admin only)
  getProjectUsers: async (projectCode, params = {}) => {
    try {
      const response = await api.get(
        `/api/admin/credits/analytics/projects/${encodeURIComponent(projectCode)}/users`,
        { params }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default creditService;
